import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import * as BsIcons from "react-icons/bs";
import { GrFormClose } from "react-icons/gr";
import { AiOutlineSearch } from "react-icons/ai";
import ReactPaginate from "react-paginate";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Button,
  Card,
  Col,
  Input,
  Label,
  Row,
  Form,
  FormGroup,
} from "reactstrap";

import { Select } from "../../../components/Inputs/Input";
import { COLUMNS } from "../constants/columns";

import * as actions from "../../../store/modules/aceiteCp/actions";
import * as controller from "../../../controllers/aceiteCpController";

import ModalEditar from "../components/ModalEditar";
import { Checkbox } from "@material-ui/core";
import { maskMoeda } from "../../../util/masks";
import ModalPessoas from "../components/ModalPessoas";
import { notifyWarn } from "../../../components/message/message";
import moment from "moment";
import { statusSelecionaveis, tipoRegraValor } from "../constants/aceite";

const Aceite = () => {
  const {
    item,
    items,
    canais,
    campanhas,
    hierarquias,
    centrosCusto,
    empresasFuncionario,
    campanhaTipo,
    statusIntegracao,
    enableCheckboxesRule,
    selectedItems,
    allItems,
    statusFavorecido,
    modalEdicao,
    totals,
    filtroAplicado,
  } = useSelector((state) => state.aceiteCp);

  const CAMPANHA_COLUNAS = {
    1: [
      "valorProdutividadeOriginal",
      "percPremioPagoProdutividade",
      "contaPagarStatusIntegracaoProdutividade",
    ],
    2: [
      "valorSuperacaoOriginal",
      "percPremioPagoSuperacao",
      "contaPagarStatusIntegracaoSuperacao",
    ],
    3: [
      "valorComissaoPagaOriginal",
      "percComissaoPaga",
      "contaPagarStatusIntegracaoRepasse",
    ],
  };

  const periodos = useMemo(
    () => [
      { id: "1", descricao: "Mês atual" },
      { id: "2", descricao: "Mês anterior" },
      { id: "3", descricao: "90 dias" },
      { id: "4", descricao: "Personalizado" },
    ],
    []
  );

  const getFilteredColumns = (tipoCampanha) => {
    if (!tipoCampanha || tipoCampanha === "0" || tipoCampanha === "") {
      return COLUMNS;
    }

    const colunasPermitidas = CAMPANHA_COLUNAS[tipoCampanha] || [];

    return COLUMNS.filter(
      (col) =>
        colunasPermitidas.includes(col.accessor) ||
        !Object.values(CAMPANHA_COLUNAS).flat().includes(col.accessor)
    );
  };

  const columns = useMemo(
    () => getFilteredColumns(filtroAplicado?.campanhaTipo),
    [filtroAplicado?.campanhaTipo]
  );

  const data = items;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    state,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageSize } = state;
  const [initialPage, setInitialPage] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);

  const handlePageClick = (e) => {
    const pageSelectedD = e.selected;
    setInitialPage(false);
    setSelectedPage(pageSelectedD);
    gotoPage(pageSelectedD);
    if (!filtroAplicado) return;
    const { sortBy } = state;

    if (sortBy.length > 0) {
      const { id, desc } = sortBy[0];
      controller.get(pageSelectedD + 1, pageSize, filtroAplicado, id, desc);
    } else {
      controller.get(pageSelectedD + 1, pageSize, filtroAplicado);
    }
  };

  function handleInitialPage(pageSizeD) {
    setInitialPage(true);
    setSelectedPage(0);
    gotoPage(0);
    if (filtroAplicado) {
      controller.get(0 + 1, pageSizeD, filtroAplicado);
    }
  }

  function resetPaginacao() {
    gotoPage(0);
    setInitialPage(true);
    setSelectedPage(0);
  }

  function handleBuscar() {
    actions.setSelectedItems([]);
    controller.get(1, pageSize, item);
    resetPaginacao();
  }

  function handleLimpar() {
    actions.cleanRegister();
    resetPaginacao();
  }

  const isSelecionavel = (row) =>
    !!enableCheckboxesRule &&
    statusSelecionaveis.includes(row.original[enableCheckboxesRule]);

  const isSelecionado = (row) =>
    selectedItems.some((selecionado) => selecionado.id === row.original.id);

  const linhasSelecionaveisPagina = page.filter(isSelecionavel);
  const todasDaPaginaSelecionadas =
    linhasSelecionaveisPagina.length > 0 &&
    linhasSelecionaveisPagina.every(isSelecionado);

  const toggleSelecionarTodosPagina = () => {
    const idsPagina = linhasSelecionaveisPagina.map((row) => row.original.id);
    const semItensPagina = selectedItems.filter(
      (selecionado) => !idsPagina.includes(selecionado.id)
    );

    actions.setSelectedItems(
      todasDaPaginaSelecionadas
        ? semItensPagina
        : [
            ...semItensPagina,
            ...linhasSelecionaveisPagina.map((row) => row.original),
          ]
    );
  };

  const [modalPessoa, setModalPessoa] = useState(false);
  const togglePessoa = () => setModalPessoa(!modalPessoa);

  const [isModalAceiteOpen, setIsModalAceiteOpen] = useState(false);

  const toggleAceiteModal = () => {
    if (selectedItems.length > 0) {
      setIsModalAceiteOpen(!isModalAceiteOpen);
    } else {
      notifyWarn("Selecione ao menos um item para aceitar.");
    }
  };

  useEffect(() => {
    if (item.canalId !== "0") {
      controller.getCampanhas(item.canalId, item.dataInicio, item.dataFim);
    }
  }, [item.canalId, item.dataInicio, item.dataFim]);

  useEffect(() => {
    if (item.canalId === "0") {
      actions.item("hierarquiaId", "0");
      actions.setHierarquias([]);
    } else {
      controller.getHierarquia(
        item.canalId,
        item.campanhaId !== "0" ? item.campanhaId : null
      );
    }
  }, [item.canalId, item.campanhaId]);

  useEffect(() => {
    if (item.campanhaId !== "0" && item.canalId !== "0") {
      controller.getCentrosCusto(item.canalId, item.campanhaId);
    }
  }, [item.canalId, item.campanhaId]);

  const fieldActions = {
    canalId: () => actions.item("campanhaId", "0"),
    periodoId: (value) => {
      if (value === "0") {
        actions.item("dataInicio", "");
        actions.item("dataFim", "");
        actions.item("campanhaId", "0");
      }
      if (value === "1") {
        const primeiroDiaMes = moment().startOf("month").format("YYYY-MM-DD");
        const ultimoDiaMes = moment().endOf("month").format("YYYY-MM-DD");

        actions.item("dataInicio", primeiroDiaMes);
        actions.item("dataFim", ultimoDiaMes);
        actions.item("campanhaId", "0");
      }
      if (value === "2") {
        const primeiroDiaMesAnterior = moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD");
        const ultimoDiaMesAnterior = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");

        actions.item("dataInicio", primeiroDiaMesAnterior);
        actions.item("dataFim", ultimoDiaMesAnterior);
        actions.item("campanhaId", "0");
      }
      if (value === "3") {
        const ultimoDiaMesAnterior = moment()
          .subtract(1, "months")
          .endOf("month");
        const primeiroDiaPeriodo = ultimoDiaMesAnterior
          .clone()
          .subtract(90, "days")
          .startOf("month")
          .format("YYYY-MM-DD");
        const ultimoDiaPeriodo = ultimoDiaMesAnterior.format("YYYY-MM-DD");

        actions.item("dataInicio", primeiroDiaPeriodo);
        actions.item("dataFim", ultimoDiaPeriodo);
        actions.item("campanhaId", "0");
      }
      if (value === "4") {
        actions.item("dataInicio", "");
        actions.item("dataFim", "");
        actions.item("campanhaId", "0");
      }
    },
    dataInicio: () => actions.item("campanhaId", "0"),
    dataFim: () => actions.item("campanhaId", "0"),
  };

  function onChange(field, value) {
    actions.item(field, value);
    if (fieldActions[field]) {
      fieldActions[field](value);
    }
  }

  useEffect(() => {
    controller.getCanais();
    controller.getCentrosCusto();
    controller.getRazaoSocialEmpresa();
    controller.getSistemas();

    return () => {
      actions.cleanRegister();
    };
  }, []);

  useEffect(() => {
    const campoValor = tipoRegraValor[modalEdicao.tipoRegraId];

    const soma = campoValor
      ? selectedItems.reduce(
          (acc, selecionado) => acc + (Number(selecionado[campoValor]) || 0),
          0
        )
      : 0;

    actions.setModalEdicaoField(soma, "valor");
  }, [modalEdicao.tipoRegraId, selectedItems]);

  const toggleItemSelection = (row) => {
    actions.setSelectedItems(
      isSelecionado(row)
        ? selectedItems.filter(
            (selecionado) => selecionado.id !== row.original.id
          )
        : [...selectedItems, row.original]
    );
  };

  const renderTotal = (columnId) => {
    switch (columnId) {
      case "metaTotal":
        return `R$ ${maskMoeda((totals.metaTotal || 0).toFixed(2))}`;
      case "producaoTotal":
        return `R$ ${maskMoeda((totals.producaoTotal || 0).toFixed(2))}`;
      case "totalPago":
        return `R$ ${maskMoeda((totals.totalPago || 0).toFixed(2))}`;
      case "receitaTotal":
        return `R$ ${maskMoeda((totals.receitaTotal || 0).toFixed(2))}`;
      case "valorComissaoPagaOriginal":
        return `R$ ${maskMoeda((totals.repasseTotal || 0).toFixed(2))}`;
      case "valorSuperacaoOriginal":
        return `R$ ${maskMoeda((totals.superacaoTotal || 0).toFixed(2))}`;
      case "valorProdutividadeOriginal":
        return `R$ ${maskMoeda((totals.produtividadeTotal || 0).toFixed(2))}`;
      // Porcentagem
      case "percAtingimentoSobreMeta":
        return `${totals.atingimentoSobreMeta || 0}%`;
      case "percTotalPagoSobreProducao":
        return `${totals.totalPagoSobreProducao || 0}%`;
      case "percTotalPagoSobreReceita":
        return `${totals.totalPagoSobreReceita || 0}%`;
      case "percReceitaTotal":
        return `${totals.receitaTotalPorcentagem || 0}%`;
      case "percComissaoPaga":
        return `${totals.repassePorcentagem || 0}%`;
      case "percPremioPagoSuperacao":
        return `${totals.superacaoPorcentagem || 0}%`;
      case "percPremioPagoProdutividade":
        return `${totals.produtividadePorcentagem || 0}%`;
      default:
        return "";
    }
  };

  return (
    <>
      <Col className="ml-3">
        <Card className="py-5 pr-5 mb-5">
          <Form
            style={{
              margin: "30px 15px",
              border: "1px solid #ccc",
              padding: "15px",
              borderRadius: "7px",
              marginBottom: "10px",
            }}
          >
            <Row>
              <Col md={3}>
                <FormGroup>
                  <Label>Canal:</Label>
                  <Select
                    first="Selecione"
                    value={{ value: item.canalId }}
                    select={{ value: "id", label: "nome" }}
                    options={canais}
                    onChange={(e) => onChange("canalId", e.value)}
                    isSearchable={true}
                    autoComplete="off"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Periodo:</Label>
                  <Select
                    first="Selecione"
                    value={{ value: item.periodoId }}
                    select={{ value: "id", label: "descricao" }}
                    options={periodos}
                    onChange={(e) => onChange("periodoId", e.value)}
                    isSearchable={true}
                    autoComplete="off"
                  />
                </FormGroup>
              </Col>
              {item.periodoId === "4" && (
                <>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Data início:</Label>
                      <Input
                        type="date"
                        value={item.dataInicio}
                        onChange={(e) => onChange("dataInicio", e.target.value)}
                        disabled={item.periodoId === "0"}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Data fim:</Label>
                      <Input
                        type="date"
                        value={item.dataFim}
                        onChange={(e) => onChange("dataFim", e.target.value)}
                        disabled={item.periodoId === "0"}
                      />
                    </FormGroup>
                  </Col>
                </>
              )}
              <Col md={3}>
                <FormGroup>
                  <Label>Campanha:</Label>
                  <Select
                    first="Selecione"
                    value={{ value: item.campanhaId }}
                    select={{ value: "id", label: "descricao" }}
                    options={campanhas}
                    onChange={(e) => onChange("campanhaId", e.value)}
                    isSearchable={true}
                    autoComplete="off"
                    disabled={item.canalId === "0"}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Hierarquia:</Label>
                  <Select
                    first="Selecione"
                    value={{ value: item.hierarquiaId }}
                    select={{ value: "hierarquiaId", label: "descricao" }}
                    options={hierarquias}
                    onChange={(e) => onChange("hierarquiaId", e.value)}
                    isSearchable={true}
                    autoComplete="off"
                    disabled={item.canalId === "0" || item.campanhaId === "0"}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label style={{ fontWeight: "700" }}>Persona:</Label>
                  <div className="d-flex flex-grow-1 align-items-center">
                    <Input
                      type="text"
                      placeholder="Busque um consultor..."
                      value={item.pessoa}
                      disabled={item.canalId === "0" || item.campanhaId === "0"}
                      className="flex-grow-1"
                    />
                    <GrFormClose
                      style={{
                        color: "#C4C7CA",
                        fontSize: "20px",
                        cursor: "pointer",
                        marginLeft: "10px",
                      }}
                      onClick={() => {
                        onChange("pessoaId", "0");
                        onChange("pessoa", "");
                      }}
                    />
                    <AiOutlineSearch
                      style={{
                        color: "var(--color-verde)",
                        fontSize: "20px",
                        cursor: "pointer",
                        marginLeft: "10px",
                      }}
                      onClick={() => togglePessoa()}
                    />
                  </div>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Centro de custo:</Label>
                  <Select
                    first="Selecione"
                    value={{ value: item.centroCustoId }}
                    select={{ value: "id", label: "descricao" }}
                    options={centrosCusto}
                    onChange={(e) => onChange("centroCustoId", e.value)}
                    isSearchable={true}
                    autoComplete="off"
                    disabled={item.canalId === "0" || item.campanhaId === "0"}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Razão social empresa:</Label>
                  <Select
                    first="Selecione"
                    value={{ value: item.empresaFuncionarioId }}
                    select={{ value: "id", label: "razaoSocialEmpresa" }}
                    options={empresasFuncionario}
                    onChange={(e) => onChange("empresaFuncionarioId", e.value)}
                    isSearchable={true}
                    autoComplete="off"
                    disabled={item.canalId === "0" || item.campanhaId === "0"}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Tipo Campanha:</Label>
                  <Select
                    first="Selecione"
                    value={{ value: item.campanhaTipo }}
                    select={{ value: "id", label: "descricao" }}
                    options={campanhaTipo}
                    onChange={(e) => onChange("campanhaTipo", e.value)}
                    isSearchable={true}
                    autoComplete="off"
                    disabled={item.canalId === "0" || item.campanhaId === "0"}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Status:</Label>
                  <Select
                    first="Selecione"
                    value={{ value: item.statusIntegracao }}
                    select={{ value: "id", label: "descricao" }}
                    options={statusIntegracao}
                    onChange={(e) => onChange("statusIntegracao", e.value)}
                    isSearchable={true}
                    autoComplete="off"
                    disabled={item.canalId === "0" || item.campanhaId === "0"}
                  />
                </FormGroup>
              </Col>

              <Col md={3}>
                <FormGroup>
                  <Label>Data Pagamento:</Label>
                  <Input
                    type="date"
                    value={item.dataPagamento}
                    onChange={(e) => onChange("dataPagamento", e.target.value)}
                    disabled={item.canalId === "0" || item.campanhaId === "0"}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Data Integração:</Label>
                  <Input
                    type="date"
                    value={item.dataIntegracao}
                    onChange={(e) => onChange("dataIntegracao", e.target.value)}
                    disabled={item.canalId === "0" || item.campanhaId === "0"}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Status do Favorecido:</Label>
                  <Select
                    first="Selecione"
                    value={{ value: item.statusFavorecido }}
                    select={{ value: "id", label: "descricao" }}
                    options={statusFavorecido}
                    onChange={(e) => onChange("statusFavorecido", e.value)}
                    isSearchable={true}
                    autoComplete="off"
                    disabled={item.canalId === "0" || item.campanhaId === "0"}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  className="clearButton"
                  onClick={() => handleLimpar()}
                >
                  Limpar
                </Button>
                <Button
                  className="purpleButton"
                  style={{ width: "150px", marginRight: "10px" }}
                  onClick={() => handleBuscar()}
                >
                  Buscar
                </Button>
                {item.campanhaId !== "0" && item.campanhaId && (
                  <Button
                    className="clearButton"
                    style={{ width: "150px", marginRight: "10px" }}
                    onClick={() => {
                      controller.downloadPlanilha(
                        item.campanhaId,
                        campanhas.find(
                          (campanha) => campanha.id === item.campanhaId
                        )?.descricao
                      );
                    }}
                  >
                    Exportar dados da campanha
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
          <div
            style={{ overflowX: "auto", marginLeft: "15px", marginTop: "30px" }}
          >
            {items.length === 0 ? (
              <div className="text-center">
                <p>Não existem dados para essa pesquisa</p>
              </div>
            ) : (
              <div
                style={{
                  overflowX: "auto",
                  marginLeft: "15px",
                  marginTop: "30px",
                }}
              >
                <table
                  {...getTableProps()}
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        <th
                          style={{
                            width: "10%",
                            padding: "7px",
                            textAlign: "center",
                          }}
                        >
                          {enableCheckboxesRule && (
                            <Checkbox
                              checked={todasDaPaginaSelecionadas}
                              disabled={linhasSelecionaveisPagina.length === 0}
                              style={{
                                color:
                                  linhasSelecionaveisPagina.length === 0
                                    ? ""
                                    : "green",
                              }}
                              onClick={() => toggleSelecionarTodosPagina()}
                            />
                          )}
                        </th>
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps()
                            )}
                            style={{
                              minWidth: "250px",
                              padding: "1px",
                              textAlign: "left",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <span style={{ marginRight: "1px" }}>
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <BsIcons.BsArrowDown />
                                  ) : (
                                    <BsIcons.BsArrowUp />
                                  )
                                ) : (
                                  <BsIcons.BsArrowDownUp />
                                )}
                              </span>
                              <span>{column.render("Header")}</span>
                            </div>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody
                    {...getTableBodyProps()}
                    style={{ verticalAlign: "top" }}
                  >
                    {page.map((row) => {
                      prepareRow(row);
                      const isSelected = isSelecionado(row);
                      return (
                        <tr
                          {...row.getRowProps()}
                          style={{
                            borderBottom: "1px solid #ddd",
                            backgroundColor: isSelected ? "#d0d3d3fc" : "",
                          }}
                        >
                          <td style={{ textAlign: "center", padding: "7px" }}>
                            {isSelecionavel(row) && (
                              <Checkbox
                                checked={isSelected}
                                style={{ color: "green" }}
                                size={"small"}
                                onClick={() => toggleItemSelection(row)}
                              />
                            )}
                          </td>
                          {row.cells.map((cell) => (
                            <td
                              {...cell.getCellProps()}
                              style={{ padding: "15px", textAlign: "left" }}
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>

                  <tfoot>
                    <tr>
                      <td className="tfoot-checkbox"></td>
                      {columns.map((column) => (
                        <td
                          key={column.accessor}
                          className={`tfoot-cell ${
                            column.align === "right"
                              ? "align-right"
                              : "align-left"
                          }`}
                        >
                          {renderTotal(column.accessor)}
                        </td>
                      ))}
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
          </div>

          <Row className="pt-4">
            <Col>
              <span style={{ color: "var(--color-cinza-medio)" }}>
                Mostrando{" "}
                {allItems.quantidade !== undefined ? allItems.quantidade : "0"}{" "}
                de{" "}
                {allItems.quantidadeTotal !== undefined
                  ? allItems.quantidadeTotal
                  : "0"}
              </span>
            </Col>
            <Col md={8}>
              <Row className="float-right">
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  initialPage={0}
                  pageCount={allItems.totalPaginas}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handlePageClick(e)}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                  forcePage={initialPage ? 0 : selectedPage}
                />
                <Input
                  type="select"
                  className="pageSize"
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                    handleInitialPage(Number(e.target.value));
                  }}
                >
                  {[10, 25, 100].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
                </Input>
              </Row>
            </Col>
          </Row>
          <Col>
            {items.length > 0 && (
              <>
                <Button
                  onClick={() => toggleAceiteModal()}
                  style={{ width: "232px", float: "right", marginLeft: "auto" }}
                  className="purpleButton"
                >
                  Aceitar itens selecionados
                </Button>
                <span
                  style={{
                    float: "right",
                    margin: "8px 15px 0 0",
                    color: "var(--color-cinza-medio)",
                  }}
                >
                  {selectedItems.length} item(s) selecionado(s)
                </span>
              </>
            )}
          </Col>
        </Card>
      </Col>
      {modalPessoa && (
        <ModalPessoas
          isOpen={modalPessoa}
          toggle={togglePessoa}
          isSearch={false}
        />
      )}
      {isModalAceiteOpen && (
        <ModalEditar
          isOpen={isModalAceiteOpen}
          toggle={() => setIsModalAceiteOpen(false)}
          pagination={{
            page: (selectedPage || 0) + 1,
            pageSize: pageSize,
          }}
        />
      )}
    </>
  );
};

export default Aceite;
